export default "__VITE_ASSET__pL5NyLE9__";